// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';
import cn from 'classnames';
// @ts-ignore
import cookie from 'cookie';
import date from '/util/date.js';
import zutil from 'zutil';
import hopt from 'hola_opt';
import {Select} from '../lib/select';
import etask from 'zetask';

export const Lang_select = props=>{
    const t_conf = zutil.get(hopt, 'www_hola.translation', {});
    const {locales = {}, path_locales = {}} = t_conf;
    const {i18n} = useTranslation();
    const {pathname} = useLocation();
    const on_select = value=>{
        cookie.set('i18next_user', value, {domain: '.hola.org',
            path: '/', expires: date.add(date(), {day: 30})});
        etask(function*(){
            yield i18n.reloadResources(value);
            yield i18n.changeLanguage(value);
        });
    };
    const lang = i18n.language;
    const r_translation = props.r_translation;
    const list = r_translation && r_translation.white_list;
    const filter_by_route = useCallback(l=>{
        return locales[l].enabled && (!list || list.includes(l) ||
            path_locales[pathname]?.includes(l));
    }, [pathname, r_translation]);
    const languages = Object.keys(locales)
        .filter(filter_by_route)
        .map(l=>({value: l, title: locales[l].full}));
    const title = props.full ? locales[lang].full : lang;
    return <Select on_select={on_select} name="lang" selected={title}
      items={languages} value={lang} class_name={cn('lang_select',
      props.white && 'lang_select--white', props.purple &&
      'lang_select--purple', props.full && 'lang_select--full')}
      expand={props.expand} top={props.purple}/>;
};
